import React from 'react';

interface IProps{
    showDialog: boolean;
    type: string;
    message: string;
    closeMethod: (e:any) => void;
    isSalesOrderMsg?: boolean;
    isExtraDocCreation?: boolean;
}

interface IState{
    showDialog: boolean;
    type: string;
    message: string;
    itemsToShow: number;
    expanded: boolean;
}

class InPageDialog extends React.Component<IProps, IState> {

    constructor(props: IProps){
        super(props);
        this.state = {
            showDialog: this.props.showDialog,
            type: this.props.type,
            message: this.props.message,
            itemsToShow: 0,
            expanded: false
        }
        this.showMore = this.showMore.bind(this);
    }

    public componentDidMount() {
        const itemLgt = this.state.message.split(/\r?\n|\r|\n/g).length;
        this.setState({ itemsToShow: itemLgt < 3 ? itemLgt : 3})
    }

    public componentDidUpdate = (prevProps:any, prevState:any) => {
        if (prevProps.showDialog !== this.props.showDialog){
            this.setState({
                showDialog: this.props.showDialog,
            });
        }
        if (prevProps.type !== this.props.type){
            this.setState({
                type: this.props.type,
            });
        }
        if (prevProps.message !== this.props.message){
            this.setState({
                message: this.props.message,
            });
        }
    }

    public render(){
        return(
            <div>
                {
                    (this.state.showDialog && !this.props.isSalesOrderMsg && !this.props.isExtraDocCreation)
                    ?
                    <div className={this.getClass()}>
                        <i aria-hidden="true" className={this.getIconClass()} />
                        <div>
                            {this.state.message.split(/\r?\n|\r|\n/g).slice(0, this.state.itemsToShow).map((item, i) => 
                                <span key={i}>{item}</span>
                            )}
                        </div>
                        { this.state.message.split(/\r?\n|\r|\n/g).length > 3 && <div>
                            <a className="large-link-text show-more-link" onClick={this.showMore}>
                                {this.state.expanded ? (
                                    <span>Show less</span>
                                ) : (
                                    <span>Show more</span>
                                )
                                }
                            </a>
                        </div>
    }
                        <i id="close_success" className="fas fa-times" onClick={this.props.closeMethod} />
                    </div>
                    : ''
                }
                {
                    (this.state.showDialog && this.props.isSalesOrderMsg)
                    ?
                    <div className={`${this.getClass()} message1`}>
                        <span className="padding-right-medium"><i aria-hidden="true" className={this.getIconClass()} /></span>
                        <div className="padding-bottom-small">
                            {this.state.message.split(':')[0]}
                        </div>
                        <div>
                            <ul>
                                {this.state.message && this.state.message.split(':')[1]?.split(',').map((item, i) => 
                                    <li key={i}>{item}</li>
                                )}
                            </ul>
                        </div>
                        <i id="close_success" className="fas fa-times" onClick={this.props.closeMethod} />
                    </div>
                    : ''
                }
                  {
                    (this.state.showDialog && this.props.isExtraDocCreation)
                    ?
                    <div className={`${this.getClass()} message1`}>
                        <span className="padding-right-medium"><i aria-hidden="true" className={this.getIconClass()} /></span>
                        <div className="padding-bottom-small">
                            {this.state.message.split(':')[0]}
                        </div>
                        <div>
                            <ul>
                                {this.state.message && this.state.message.split('--')[1].split(',').map((item, i) => 
                                    <li key={i}>{item}</li>
                                )}
                                 {this.state.message && this.state.message.split('--')[2] && this.state.message.split('--')[2].split(',').map((item, i) => 
                                    <li key={i}>{item}</li>
                                )}
                            </ul>
                        </div>
                        <i id="close_success" className="fas fa-times" onClick={this.props.closeMethod} />
                    </div>
                    : ''
                }
            </div>
        );
    }

    public getClass = (): any => {
        switch(this.state.type){
            case 'info':
            return 'message info';

            case 'success':
            return 'message success';

            case 'warning':
            return 'message warning';

            case 'error':
            return 'message failed';
        }
    }

    public getIconClass = (): any => {
        switch(this.state.type){
            case 'info':
            return 'fas fa-info-circle';

            case 'success':
            return 'fas fa-check-circle';

            case 'warning':
            return 'fas fa-exclamation-triangle';

            case 'error':
            return 'fas fa-times-circle';
        }
    }

    public showMore = (): any => {
        this.setState({ expanded: !this.state.expanded })
        this.state.itemsToShow === 3 ? (
          this.setState({ itemsToShow: this.state.message.split(/\r?\n|\r|\n/g).length })
        ) : (
          this.setState({ itemsToShow: 3 })
        )
      }
}

export default InPageDialog;